import { mapActions, mapState } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteMixin } from '../Site/SelectedSiteMixin'

export const ContactRelationshipOptionsCacheMixin = {
  mixins: [SelectedSiteMixin],
  computed: {
    ...mapState('ContactRelationshipOptions', [
      'contactRelationshipOptions',
      'fetchingContactRelationshipOptions',
      'fetchedContactRelationshipOptions'
    ])
  },
  watch: { selectedSiteId () { this.refreshContactRelationshipOptions() } },
  methods: {
    ...mapActions('ContactRelationshipOptions', ['fetchContactRelationshipOptionsBySiteId']),
    refreshContactRelationshipOptions () {
      if (!this.fetchedContactRelationshipOptions && !this.fetchingContactRelationshipOptions && this.selectedSiteId) {
        this.fetchContactRelationshipOptionsBySiteId(this.selectedSiteId)
          .catch(error => { this.error = ErrorHelper.getError(error) })
      }
    }
  },
  created () { this.refreshContactRelationshipOptions() }
}
